<template>
  <v-container fluid>
    <v-card class="card-rounded">
      <v-form ref="relatorioForm" lazy-validation>
        <v-card-title>
          <span class="headline">Relatório de Apostas</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="params.numero"
                label="Número Concurso"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <date-picker
                :label="'Data Inicial'"
                v-model="params.dataInicial"
              ></date-picker>
            </v-col>
            <v-col cols="4">
              <date-picker
                :label="'Data Final'"
                v-model="params.dataFinal"
              ></date-picker>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onClickView">
            Visualizar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import util from "@/service/util-service";
import DatePicker from "../../components/date-picker.vue";

export default {
  components: {
    "date-picker": DatePicker,
  },
  data() {
    return {
      params: {},
    };
  },
  methods: {
    onClickView() {
      this.$store
        .dispatch("getRelatorioApostas", this.params)
        .then((value) => {
          var byteCharacters = atob(value);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: "application/pdf;base64" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text:
              "Ouve um erro ao processar sua solicitação! Tente novamente mais tarde.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
